'use strict';

function languageService($http, $translate) {
  var api = '/api/core/language/';

  return {
    list: list,
    update: update
  };

  function list() {
    return $http.get(api).then(function(response) {
      return response.data;
    });
  }

  function update(language) {
    return $http.post(api, { code: language }).then(function(response) {
      return $translate.use(response.data.code);
    });
  }
}

module.exports = languageService;



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/app/services/language.service.js
 ** module id = 314
 ** module chunks = 0
 **/